// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__sHjFg","sk-bouncedelay":"spinner_sk-bouncedelay__hIfPm","bounce1":"spinner_bounce1__Ke5tX","bounce2":"spinner_bounce2__5V4aw"};